import { EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, merge } from 'rxjs';
import { AuthService } from '../../../../core/auth/auth.service';
import { MenuCategory } from '../../../menu/menu-category.model';
import { Menu } from '../../../menu/menu.model';
import { MenuService } from '../menu.service';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { FullMenuService } from '@app/full-menu/full-menu.service';
import { Router } from '@angular/router';
import { FeatureToggleService } from '@app/shared/feature-toggle/feature.toggle.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { detailFromBreadcrumb, normalizePath, normalizePathFromBreadcrumb } from '@app/shared/utils';
var MenuCategoryOptionComponent = /** @class */ (function () {
    function MenuCategoryOptionComponent(translate, menuService, authService, _window, itauUserIdleService, sessionService, fullMenuService, router, featureToggleService, _sdkAnalyticsService) {
        if (translate === void 0) { translate = null; }
        this.translate = translate;
        this.menuService = menuService;
        this.authService = authService;
        this._window = _window;
        this.itauUserIdleService = itauUserIdleService;
        this.sessionService = sessionService;
        this.fullMenuService = fullMenuService;
        this.router = router;
        this.featureToggleService = featureToggleService;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.showAllOptions = new EventEmitter();
        this.clickHideMenu = new EventEmitter();
    }
    MenuCategoryOptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    };
    Object.defineProperty(MenuCategoryOptionComponent.prototype, "name", {
        get: function () {
            if (!this.option)
                return "";
            return this.option.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryOptionComponent.prototype, "translationKey", {
        get: function () {
            if (!this.option)
                return "";
            return this.option.translationKey + ".TRANSLATION";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryOptionComponent.prototype, "subOptions", {
        get: function () {
            if (!this.hasSubOptions)
                return [];
            var filteredList = this.option.subMenus.filter(function (item, index) { return index < 5; });
            return filteredList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryOptionComponent.prototype, "hasOptions", {
        get: function () {
            return !!this.option;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryOptionComponent.prototype, "hasSubOptions", {
        get: function () {
            if (!this.option)
                return false;
            if (!this.option.subMenus)
                return false;
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuCategoryOptionComponent.prototype, "hasManySubOptions", {
        get: function () {
            if (!this.hasSubOptions)
                return false;
            if (this.option.subMenus.length <= 5)
                return false;
            return true;
        },
        enumerable: true,
        configurable: true
    });
    MenuCategoryOptionComponent.prototype.openFullMenu = function () {
        this.showAllOptions.emit(true);
        this.fullMenuService.setSelectedTranslationKeyCategory(this.option.translationKey);
        this.menuService.fullMenu(this.translate.currentLang, this.category.name.toLowerCase(), this.name, new Date().getTime());
    };
    MenuCategoryOptionComponent.prototype.paramsModel = function (user) {
        return {
            sessao: user.token,
            id: user.idSessao,
            idsessao: user.idConexao,
            gestor: user.gestor,
            nomeUsu: user.name,
            iDFuncao: user.tipo,
        };
    };
    MenuCategoryOptionComponent.prototype.openModal = function (context) {
        var codFunction = context.id;
        var name = context.name;
        var url = context.url;
        if (context.path && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: detailFromBreadcrumb(context.path)
            });
        }
        if (/IS\/#/.test(url)) {
            this.router.navigate(["" + url.split('/#')[1]]);
            return false;
        }
        var sUrl = this.authUser.serverEstatisticas + "?xyz=0";
        try {
            this.itauUserIdleService.stopWatching();
            this.sessionService.updateSession().subscribe(function () { });
            var userType = this.authUser.tipo == 1 ? "A" : "C";
            sUrl += this.getQueryString(this.authUser.token, this.authUser.idSessao, this.authUser.idConexao, this.authUser.gestor, this.authUser.name, userType);
            sUrl += this.getQueryStringFunction(codFunction);
            var windowOK4 = this._window.open(sUrl, name, "directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5");
            this._sdkAnalyticsService.trackEvent('screen_view', {
                custom_path: normalizePathFromBreadcrumb(context.path, { prefix: '/iss/lg/' }),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: detailFromBreadcrumb(context.path)
            });
            this.itauUserIdleService.setCustomActivityEvents(merge(fromEvent(window, "mousemove"), fromEvent(window, "resize"), fromEvent(document, "keydown"), fromEvent(document, "touchstart"), fromEvent(document, "touchend"), fromEvent(windowOK4, "mousemove"), fromEvent(windowOK4, "resize")));
            this.itauUserIdleService.startWatching();
        }
        catch (ex) {
            throw ex;
        }
    };
    MenuCategoryOptionComponent.prototype.openModalContext = function (context) {
        if (context.path && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: detailFromBreadcrumb(context.path)
            });
        }
        this.menuService.openContext(context.url);
        this.clickHideMenu.emit(context.url);
    };
    MenuCategoryOptionComponent.prototype.getQueryStringFunction = function (codFunction) {
        try {
            return "&iDFuncao=" + -1 * codFunction;
        }
        catch (ex) {
            throw ex;
        }
    };
    MenuCategoryOptionComponent.prototype.getQueryString = function (token, idConnection, idSession, sGestor, nameUser, userType) {
        try {
            return ("&sessao=" +
                token +
                "&id=" +
                idConnection +
                "&idsessao=" +
                idSession +
                "&gestor=" +
                sGestor +
                "&nomeUsu=" +
                nameUser +
                "&tipousu=" +
                userType);
        }
        catch (ex) {
            throw ex;
        }
    };
    MenuCategoryOptionComponent.prototype.submitEvent = function (pageName) {
    };
    MenuCategoryOptionComponent.prototype.goToiServices = function (url) {
        if (this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: 'menu-iservices'
            });
        }
        this.featureToggleService.goToiServices(url);
    };
    return MenuCategoryOptionComponent;
}());
export { MenuCategoryOptionComponent };
